export default __webpack_public_path__ + "static/media/rect_checkbox_icon_checked.66b48743.svg";